export default __webpack_public_path__ + "static/services-detailsdm-ad83c4e228a15d18553e5ab155110185.jpg";